import { forwardRef } from "react"
import { mergeClasses } from "@lib/css"

import type { IconProps } from "./types"

export const IconPlayFilled = forwardRef<SVGSVGElement, IconProps>(
  function IconPlay(props, ref) {
    const { className, title, titleId, ...otherProps } = props
    const defaultClasses =
      "w-18 h-18 flex-shrink-0 fill-current transition-colors duration-150 ease-in focus:outline-none"
    const classes = mergeClasses(defaultClasses, className)

    return (
      <svg
        ref={ref}
        viewBox="0 0 71 71"
        focusable="false"
        aria-hidden="true"
        tabIndex={-1}
        className={classes}
        aria-labelledby={titleId}
        {...otherProps}
      >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
          d="M57.6914 4.4375H13.3164C10.9626 4.4375 8.70522 5.37254 7.04083 7.03693C5.37645 8.70131 4.44141 10.9587 4.44141 13.3125V57.6875C4.44141 60.0413 5.37645 62.2987 7.04083 63.9631C8.70522 65.6275 10.9626 66.5625 13.3164 66.5625H57.6914C60.0452 66.5625 62.3026 65.6275 63.967 63.9631C65.6314 62.2987 66.5664 60.0413 66.5664 57.6875V13.3125C66.5664 10.9587 65.6314 8.70131 63.967 7.03693C62.3026 5.37254 60.0452 4.4375 57.6914 4.4375ZM26.6289 51.3862H26.0964C25.9181 51.2944 25.7693 51.154 25.6672 50.9813C25.5652 50.8086 25.514 50.6105 25.5195 50.41V20.7231C25.514 20.5226 25.5652 20.3246 25.6672 20.1518C25.7693 19.9791 25.9181 19.8387 26.0964 19.7469C26.2684 19.636 26.4687 19.5771 26.6733 19.5771C26.8779 19.5771 27.0782 19.636 27.2502 19.7469L49.4377 34.5237C49.5844 34.6308 49.7037 34.7711 49.786 34.933C49.8683 35.0949 49.9112 35.274 49.9112 35.4556C49.9112 35.6373 49.8683 35.8163 49.786 35.9783C49.7037 36.1402 49.5844 36.2804 49.4377 36.3875L27.2502 51.1644C27.0733 51.3051 26.8548 51.3831 26.6289 51.3862Z"
          fill="white"
        />
      </svg>
    )
  },
)
